import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { HttpHandlerFn, HttpRequest, provideHttpClient, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './core/interceptors/auth.interceptor';

// Cache-busting interceptor
export function cacheBustingInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  // Only add cache busting to JSON files
  if (req.url.includes('.json')) {
    const modifiedReq = req.clone({
      setHeaders: {
        'Cache-Control': 'no-cache, no-store, must-revalidate',
        'Pragma': 'no-cache',
        'Expires': '0'
      },
      setParams: {
        '_t': Date.now().toString()
      }
    });
    return next(modifiedReq);
  }
  return next(req);
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([cacheBustingInterceptor, authInterceptor])
    )
  ]
};
